module.exports = __webpack_public_path__ + "static/media/foto9.c5186f5b.jpeg";